import { getNormalPath } from '@/utils/mei-mei'
import { isExternal } from '@/utils/validate'

export function resolveMenuPath(basePath, routePath) {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(basePath)) {
    return basePath
  }
  if (routePath === undefined || routePath === null) {
    return getNormalPath(basePath || '')
  }
  return getNormalPath(`${basePath}/${routePath}`)
}

export function resolveMenuPathWithQuery(basePath, routePath, routeQuery) {
  if (routeQuery) {
    const query = JSON.parse(routeQuery)
    return {
      path: resolveMenuPath(basePath, routePath),
      query,
    }
  }
  return resolveMenuPath(basePath, routePath)
}

function shouldRenderSubMenu(item) {
  const children = item.children || []
  const showingChildren = children.filter((child) => !child.hidden)

  if (showingChildren.length === 1 && !item.alwaysShow) {
    return false
  }

  if (showingChildren.length === 0) {
    return false
  }

  return true
}

export function collectSubMenuOpenKeys(routes = []) {
  const keys = []

  function walk(item, basePath) {
    if (!item || item.hidden) {
      return
    }

    const children = (item.children || []).filter((child) => !child.hidden)
    if (!children.length) {
      return
    }

    if (shouldRenderSubMenu(item)) {
      keys.push(resolveMenuPath(basePath, item.path))
      children.forEach((child) => {
        walk(child, resolveMenuPath(basePath, item.path))
      })
      return
    }

    if (children.length === 1) {
      walk(children[0], resolveMenuPath(basePath, item.path))
    }
  }

  routes.forEach((route) => {
    walk(route, route.path)
  })

  return [...new Set(keys.filter(Boolean))]
}
